import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent
    navigator.clipboard.writeText(text).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "コピーしました！"
      setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
    }).catch(() => {
      this.buttonTarget.textContent = "コピーできませんでした"
      setTimeout(() => { this.buttonTarget.textContent = "コピー" }, 2000)
    })
  }
}
